'use strict';

/* global angular */
/**
 * @typedef {string} AuthToken - An authentication token retrieved from the AuthenticationService.
 * @typedef {string} Alias - A content identifier consisting of a namespace and an id; "namespace/id"
 * @typedef {string} Version - A content version identifier.
 *
 * @typedef {Object} Content - An object representing a content as retrieved or passed to server.
 * @property {Object} system - TODO
 * @property {Object} operations - TODO
 * @property {Object} aspects - TODO
 *
 * @typedef {Object} Operations - TODO
 * @property {Object} system -
 * @property {Object} operations -
 * @property {Object} aspects -
 *
 */
angular.module ('atex.aceui.service', ['atex.aceui.application', 'atex.aceui.ui']);
